import { CmcdTransmissionMode } from './CmcdTransmissionMode.js';
/**
 * CMCD encoding types.
 *
 * @group CMCD
 *
 * @enum
 *
 * @beta
 *
 * @deprecated Use {@link CmcdTransmissionMode} instead.
 *
 * @see {@link CmcdTransmissionMode}
 */
export const CmcdEncoding = CmcdTransmissionMode;
//# sourceMappingURL=CmcdEncoding.js.map